import React from 'react';
import {
  Box,
  Container,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import Link from '@material-ui/core/Link';
import Modal from '@mui/material/Modal';
import { height } from 'styled-system';

import { Button } from '@components';
import {
  getLanguagePrefix,
  getLocalizedContent as l,
} from '@helpers/languages';
import { BackLink } from '@components/BackLink/BackLink';
import content from './FinancingConsentModal.json';
import {
  LOAN_LEASE_DEFI_URI,
  LOAN_LEASE_BUSINESS_FINANCING_URI,
} from '@constants';
import financingBackgroundImage from '@images/background-the-lucid-relationship.jpeg';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'SchnyderSLight',
  },
  content: {
    fontWeight: '400',
  },
  container: {
    marginTop: '74px',
  },
  desktopButton: {
    maxWidth: '16rem',
  },
  primaryBtn: {
    backgroundColor: '#1B1B1B !important',
    color: 'white !important',
    width: '100% !important',
    maxHeight: '56px !important',
    fontFamily: 'GTAmerica',
    lineHeight: '20px !important',
    fontWeight: '400 !important',
    textDecorationStyle: 'solid !important',
    textSizeAdjust: 'auto',
    '&:active, &:hover': {
      backgroundColor: '#555354 !important',
      color: 'white !important',
    },
  },
  interestRateBox: {
    fontFamily: 'SchnyderWideM',
    fontSize: '10vw',
    fontWeight: '500',
    display: 'flex',
    width: 'max-content',
    border: '1px solid #3D3D3D',
    '@media screen and (min-width: 700px)': {
      fontSize: '3rem',
    },
  },
  wrapper: {
    height: '100vh',
    width: '100%',
    display: 'grid',
  },
  mobileBanner: {
    fontFamily: 'SchnyderWideM',
    fontSize: '3vmax',
    lineHeight: '135%',
    textAlign: 'center',
    color: '#FFFFFF',
    background: '#1B1B1B',
    padding: '4vmax 8vmax',
  },
  imgDesktopWrapper: {
    width: '90%',
    marginLeft: '10px',
  },
  imgMobileWrapper: {
    width: '100%',
  },
  boxAlign: {
    marginTop: '2rem',
    marginLeft: '1rem',
    width: '90%',
  },
  desktopBanner: {
    position: 'absolute',
    fontFamily: 'SchnyderWideM',
    lineHeight: '135%',
    textAlign: 'center',
    background: '#1B1B1B',
    left: '18%',
    top: '22%',
    padding: '15% 40%',
  },
  desktopOverlayOnclickBanner: {
    position: 'absolute',
    fontFamily: 'SchnyderWideM',
    lineHeight: '135%',
    textAlign: 'center',
    background: '#1B1B1B',
    left: '25%',
    top: '30%',
    padding: '10% 25%',
    '@media screen and (min-width: 741px) and (max-width: 970px)': {
      fontSize: '2rem',
      top: '50%',
      padding: '30% 25% ',
    },
    '@media screen and (min-width: 300px) and (max-width: 740px)': {
      fontSize: '2rem',
      top: '50%',
      padding: '30% 25% 70%',
    },
  },
  desktopBannerText: {
    position: 'absolute',
    fontFamily: 'SchnyderWideM',
    lineHeight: '135%',
    textAlign: 'center',
    color: '#FFFFFF',
    left: '0',
    top: '0',
    margin: '6% 10%',
    fontSize: '48px',
    '@media screen and (min-width: 741px) and (max-width: 970px)': {
      fontSize: '4.8vw',
      margin: '5% 9%',
    },
    '@media screen and (min-width: 600px) and (max-width: 740px)': {
      fontSize: '4.8vw',
      margin: '5% 9%',
    },
  },
}));

export const FinancingConsentModal = ({ orderId }) => {
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const onBackClick = () =>
    window.location.assign(
      `${window.location.origin}${getLanguagePrefix(language)}/portal/designs`
    );

  return (
    <Box className={classes.wrapper}>
      <Container maxWidth="md">
        {/* Back button */}
        <Grid container spacing={3} className={classes.container}>
          <Grid item xs={3}>
            <BackLink onClick={onBackClick} />
          </Grid>
        </Grid>

        {isMobile ? (
          <Grid item xs={12} style={{ marginTop: '2rem' }}>
            <Typography className={classes.mobileBanner}>
              {l(content.financeContent, language)}
            </Typography>
            <img
              src={financingBackgroundImage}
              className={classes.imgMobileWrapper}
            />
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
              aria-describedby="modal-modal-description"
            >
              <Grid
                item
                xs={12}
                className={classes.desktopOverlayOnclickBanner}
              >
                <Typography
                  className={classes.desktopBannerText}
                  style={{ fontSize: '2rem', paddingTop: '5%' }}
                >
                  You are leaving Lucid website to Bank of America financial
                  space
                </Typography>
              </Grid>
            </Modal>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            style={{ marginTop: '2rem', position: 'relative' }}
          >
            <Grid item xs={12} className={classes.desktopBanner}>
              <Typography className={classes.desktopBannerText}>
                {l(content.financeContent, language)}
              </Typography>
            </Grid>
            <img
              src={financingBackgroundImage}
              className={classes.imgDesktopWrapper}
            />
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
              aria-describedby="modal-modal-description"
            >
              <Grid
                item
                xs={12}
                className={classes.desktopOverlayOnclickBanner}
              >
                <Typography
                  className={classes.desktopBannerText}
                  style={{ fontSize: '3vw', paddingTop: '5%' }}
                >
                  You are leaving Lucid website to Bank of America financial
                  space
                </Typography>
              </Grid>
            </Modal>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          style={{ marginTop: '2rem', width: '90%', marginLeft: '1rem' }}
        >
          {/* Buttons */}
          {/* Mobile Buttons */}
          {isMobile ? (
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Link target="_blank" href={`${LOAN_LEASE_DEFI_URI}`}>
                  <Button
                    text={l(content.personalFinancing, language)}
                    className={classes.primaryBtn}
                    onClick={handleOpen}
                  />
                </Link>
              </Grid>
              <Grid item xs={12} style={{ marginTop: '1rem' }}>
                <Link target="_blank" href={LOAN_LEASE_BUSINESS_FINANCING_URI}>
                  <Button
                    text={l(content.businessFinancing, language)}
                    className={classes.primaryBtn}
                    onClick={handleOpen}
                  />
                </Link>
                <Typography variant="body2" style={{ marginTop: '1rem' }}>
                  {l(content.businessFinancingPlaceholder, language)}
                </Typography>
              </Grid>
            </Grid>
          ) : (
            // Desktop Buttons
            <Grid item xs={12} container>
              <Grid
                item
                xs={12}
                container
                style={{ justifyContent: 'center' }}
                spacing={2}
              >
                <Grid item xs={6}>
                  <Link
                    target="_blank"
                    href={`${LOAN_LEASE_DEFI_URI}`}
                    onClick={handleOpen}
                  >
                    <Button
                      text={l(content.personalFinancing, language)}
                      className={classes.primaryBtn}
                    />
                  </Link>
                </Grid>
                <Grid item xs={6}>
                  <Link
                    target="_blank"
                    href={LOAN_LEASE_BUSINESS_FINANCING_URI}
                  >
                    <Button
                      text={l(content.businessFinancing, language)}
                      style={{ border: '1px solid #3D3D3D' }}
                      className={classes.primaryBtn}
                      onClick={handleOpen}
                    />
                  </Link>
                  <Typography variant="body2" style={{ marginTop: '1rem' }}>
                    {l(content.businessFinancingPlaceholder, language)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} className={classes.boxAlign}>
          <Divider />
        </Grid>
        <Grid item xs={12} className={classes.boxAlign}>
          <Typography variant="body2">{l(content.body1, language)}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.boxAlign}
          style={{ marginBottom: '3em' }}
        >
          <Typography variant="body2">{l(content.body4, language)}</Typography>
        </Grid>
      </Container>
    </Box>
  );
};
